import { jsx as _jsx } from "react/jsx-runtime";
import { styled, Sensor, IconButton, Tooltip, Spinner } from '@streem/ui-react';
import { useCallback, useEffect, useState } from 'react';
import { CameraRequestState } from '../video_frame';
import { CameraRequestPrompt, CameraRequestDeniedOrAborted, CameraRequestPending, } from './camera_request_messages';
export function FlipCameraButton({ cameraSubject, cameraRequestState, isCameraFlipRequest, onRequest, onCancel, }) {
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const [tooltipMessage, setTooltipMessage] = useState();
    const [hover, setHover] = useState(false);
    const [hoverMessage, setHoverMessage] = useState();
    const pendingRequest = cameraRequestState === CameraRequestState.PENDING && isCameraFlipRequest;
    const deniedRequest = cameraRequestState === CameraRequestState.REQUEST_DENIED && isCameraFlipRequest;
    const abortedRequest = cameraRequestState === CameraRequestState.REQUEST_TIMEOUT && isCameraFlipRequest;
    const initialRequest = cameraRequestState === CameraRequestState.INITIAL;
    useEffect(() => {
        if (initialRequest) {
            setHoverMessage(_jsx(CameraRequestPrompt, { cameraSubject: cameraSubject }));
        }
        else if (pendingRequest) {
            setHoverMessage(_jsx(CameraRequestPending, {}));
        }
    }, [initialRequest, pendingRequest, cameraSubject]);
    useEffect(() => {
        if (deniedRequest || abortedRequest) {
            setTooltipMessage(_jsx(CameraRequestDeniedOrAborted, { requestState: cameraRequestState, onCancel: () => {
                    setTooltipOpen(false);
                    onCancel();
                }, onRequest: () => {
                    setTooltipOpen(false);
                    onRequest();
                } }));
            setTooltipOpen(true);
        }
    }, [deniedRequest, onRequest, onCancel, abortedRequest, cameraRequestState]);
    const closeTooltip = useCallback(() => {
        if (tooltipOpen) {
            setTooltipOpen(false);
            onCancel();
        }
    }, [tooltipOpen, onCancel]);
    const handleMouseEnter = useCallback(() => {
        setHover(true);
    }, []);
    const handleMouseLeave = useCallback(() => {
        setHover(false);
    }, []);
    const handleClick = useCallback(() => {
        if (initialRequest) {
            onRequest();
        }
    }, [initialRequest, onRequest]);
    return (_jsx(Sensor, { onClickOutside: closeTooltip, onEscape: closeTooltip, children: _jsx(Tooltip, { placement: "right", fallbackPlacements: ['left', 'top'], distance: 20, showTooltip: tooltipOpen || hover, message: tooltipOpen ? tooltipMessage : hoverMessage, borderRadius: "6px", offsetValue: cameraRequestState === CameraRequestState.PENDING && isCameraFlipRequest
                ? 0
                : 15, children: pendingRequest ? (_jsx(SpinnerContainer, { onMouseOver: handleMouseEnter, onMouseOut: handleMouseLeave, children: _jsx(Spinner, { size: "40px", color: "white" }) })) : (_jsx(FlipCameraIconButton, { label: 'Request Opposite Camera', iconName: 'FlipIcon', background: 'black', fill: 'white', onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave })) }) }));
}
const FlipCameraIconButton = styled(IconButton) `
    opacity: 0.9;
    margin-bottom: 8px;

    &:active {
        opacity: 0.64;
        transform: scale(0.92);
    }
`;
const SpinnerContainer = styled.div `
    opacity: 0.9;
    margin-bottom: 8px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
`;
//# sourceMappingURL=flip_camera_button.js.map